import React, { Children, useMemo } from 'react'
import { Bleed, Separator } from '@fs/zion-ui'
import { css } from '@emotion/core'
import { getCustomImage, getCustomPageFlavor } from '../../helpers'
import { useOneOffPageData } from '../../../hooks'
import { backgroundSponsorCarouselJpg } from '../../../images'
import { SectionCard } from '../../section-card'
import { flavors } from '../../../config'

const timeForOneItem = 6 // seconds for one item to scroll across

const imageCss = css`
  display: flex;
  justify-content: center;
  align-items: center;
  width: var(--item-width);
`
const getContainerCss = (itemCount) => css`
  --item-width: 180px;
  --gap: 50px;
  display: flex;
  gap: var(--gap);
  width: max-content;
  height: 160px;
  will-change: transform;
  animation: seamlessScroll ${timeForOneItem * itemCount}s linear infinite;

  @keyframes seamlessScroll {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(calc(-1 * (var(--item-width) + var(--gap)) * ${itemCount}));
    }
  }
`

const InfiniteRotatingCarousel = ({ data }) => {
  const duplicatedItems = useMemo(() => {
    if (!data || data.length === 0) return []
    // Duplicate items for smooth infinite scroll
    return [...data, ...data]
  }, [data])

  if (duplicatedItems.length === 0) return null

  const originalItemCount = data.length

  return (
    <Bleed sides style={{ overflow: 'hidden' }}>
      <div css={getContainerCss(originalItemCount)}>
        {Children.toArray(
          duplicatedItems.map((item) => (
            <div css={imageCss}>
              {/* Zion's Image caused too much flickering */}
              <img style={{ width: '100%' }} alt="" src={getCustomImage(item)} />
            </div>
          ))
        )}
      </div>
    </Bleed>
  )
}

export default function SponsorCarouselBanner({ heading, description, actions }) {
  const { data } = useOneOffPageData({ path: '/rotating-sponsor-banner' })
  const pageFlavor = getCustomPageFlavor(data?.colorScheme)
  const flavor = pageFlavor || flavors.default
  const content = data?.content

  return (
    <SectionCard
      flavor={flavor}
      image={backgroundSponsorCarouselJpg}
      heading={heading}
      description={description}
      actions={actions}
      size="sm"
    >
      <Separator size="sm" />
      <InfiniteRotatingCarousel data={content?.[0]?.items || []} />
    </SectionCard>
  )
}
